import { cx } from '@emotion/css';
import { Button, Divider } from 'antd';
import { CopyText } from 'components/LightConversation/components/CopyText';
import { ProductInfoImage } from 'components/LightConversation/components/ProductInfo/Image';
import { ProductInfoPrice } from 'components/LightConversation/components/ProductInfo/Price';
import { ProductInfoTitle } from 'components/LightConversation/components/ProductInfo/Title';
import { useTranslate } from '@tolgee/react';
import { ProductInfoSkuGrid } from 'components/LightConversation/components/ProductInfo/SkuGrid';
import { useRef } from 'react';
import PreOrder from 'views/Conversation/Sider/Item/PreOrder';
import styled from '@emotion/styled';

interface ProductItemProps {
  platform?: General.PlatformUpperCase;
  item: Conversation.Product;
  onSend: (item: Conversation.Product) => void;
}

export const ProductItem = (props: ProductItemProps) => {
  const { item, onSend, platform } = props;
  const { t } = useTranslate();
  const {
    itemName,
    itemUrl,
    imageUrl,
    unit,
    originalHighPrice,
    skuLowPrice,
    skuHighPrice,
    itemSku,
    skuInfo,
    internalStoreId,
    preOrderStatus,
  } = item;
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className={cx(
        'group p-3 border border-solid border-[#F0F2F5] rounded hover:bg-[#F0F7FF] cursor-pointer flex items-start gap-2 self-start',
      )}
    >
      <ProductInfoImage imgUrl={imageUrl?.[0]} itemName={itemName} platform={platform} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TitleWrapper>
          <PreOrder platform={platform} preOrderStatus={preOrderStatus} />
          <ProductInfoTitle title={itemName} url={itemUrl} />
        </TitleWrapper>
        <ProductInfoPrice
          unit={unit}
          originalHighPrice={originalHighPrice}
          skuLowPrice={skuLowPrice}
          skuHighPrice={skuHighPrice}
        />
        <div className="flex items-center">
          {!!itemSku && (
            <>
              <CopyText
                text={itemSku}
                className="text-xs text-[#84868C] max-w-[120px]"
                tooltip={itemSku}
              />
              <Divider type="vertical" />
            </>
          )}
          <ProductInfoSkuGrid
            containerRef={containerRef}
            storeId={internalStoreId}
            skuInfo={skuInfo}
            preOrderStatus={preOrderStatus}
          />
        </div>
      </div>
      <div className="h-full flex-shrink-0 items-center justify-center pr-4 pl-6 hidden group-hover:flex">
        <Button
          type="primary"
          onClick={() => {
            onSend(item);
          }}
        >
          {t('scene.chatWorkspace.productTab.action.send')}
        </Button>
      </div>
    </div>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  > div {
    flex: 1 0 0;
    overflow: hidden;
  }
`;
